module.exports = __webpack_public_path__ + "static/media/11-min.d1621c24.png";